import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import AssetModel from 'cio/models/asset';

interface AssetLibraryBaseItemArgs {
  asset: AssetModel;

  onCopy?: (asset: AssetModel) => unknown;
  onPreview?: (asset: AssetModel) => unknown;
  onDelete?: (asset: AssetModel) => unknown;

  onSelect: (asset: AssetModel) => unknown;
  unselectableAssetReasons?: Record<string, string>;

  onCheck?: (checked: boolean, asset: AssetModel) => unknown;
  isChecked?: boolean;

  draggableOptions?: any;
  onBeforeDragStart?: (asset: AssetModel) => unknown;
  onDrop?: (asset: AssetModel) => unknown;
}

export default abstract class AssetLibraryBaseItemComponent extends Component<AssetLibraryBaseItemArgs> {
  @tracked isDroppingOver = false;

  get classNames() {
    let classes: string[] = [];

    if (this.unselectableReason != null) {
      classes.push('asset-library__item--unselectable');
    }

    if (this.isDroppingOver) {
      classes.push('asset-library__item--dropping-over');
    }

    if (this.args.isChecked === true) {
      classes.push('asset-library__item--checked');
    }

    if (this.args.asset.isDir) {
      classes.push('asset-library__folder');
    } else if (this.args.asset.isPdf) {
      classes.push('asset-library__pdf');
    } else {
      classes.push('asset-library__image');
    }

    return classes.join(' ');
  }

  get unselectableReason() {
    return this.args.unselectableAssetReasons?.[this.args.asset.id] ?? null;
  }

  get isDroppable() {
    return this.args.asset.isDir && this.args.isChecked !== true;
  }

  @action
  onBeforeDragStart() {
    this.args.onBeforeDragStart?.(this.args.asset);
  }

  @action
  onDragEnd() {
    if (this.isDroppingOver) {
      this.isDroppingOver = false;
    }
  }

  @action
  onDropOver() {
    if (!this.isDroppable) {
      return;
    }

    this.isDroppingOver = true;
  }

  @action
  onDropLeave() {
    if (!this.isDroppable) {
      return;
    }

    this.isDroppingOver = false;
  }

  @action
  onDrop() {
    if (!this.isDroppable) {
      return;
    }

    this.isDroppingOver = false;
    this.args.onDrop?.(this.args.asset);
  }
}
